import { ButtonBase } from "@mui/material";
import { useIntl } from "react-intl";

import { IconGreenPlus } from "@/components/Icons";

interface Props {
  servicesSelectedCount?: number;
  onClick: () => void;
}

export const SelectedAdditionalServicesCard = ({
  servicesSelectedCount,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <ButtonBase
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "start",
        gap: "calc(var(--spacing) * 2)",
        borderRadius: "var(--radius-2xl)",
        backgroundColor: "var(--color-surface-neutral-soft)",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "var(--color-surface-neutral-medium)",
        padding: "calc(var(--spacing) * 3)",
        textAlign: "start",
        fontSize: "var(--text-sm)",
        fontWeight: "var(--font-weight-medium)",
      }}
      onClick={onClick}
    >
      <IconGreenPlus />
      <div className="flex flex-col gap-0.5 text-sm">
        <div className="font-medium text-text-primary">
          {intl.formatMessage({
            defaultMessage: "Additional services",
            description: "travellers.additionalServices",
          })}
        </div>
        {servicesSelectedCount ? (
          <div className="font-medium text-core-accent-600">
            {intl.formatMessage(
              {
                defaultMessage:
                  "{count, plural, one {# service} other {# services}} selected",
                description: "travellers.xServicesSelected",
              },
              { count: servicesSelectedCount },
            )}
          </div>
        ) : (
          <div className="text-text-tertiary">
            {intl.formatMessage({
              defaultMessage: "No services selected",
              description: "travellers.noServicesSelected",
            })}
          </div>
        )}
      </div>
      <div className="my-auto ms-auto leading-5 font-bold text-text-interactive">
        {servicesSelectedCount
          ? intl.formatMessage({ defaultMessage: "Edit", description: "edit" })
          : intl.formatMessage({ defaultMessage: "Add", description: "add" })}
      </div>
    </ButtonBase>
  );
};
